import { RouteInfo } from '../admin-template/sidebar-menu.data';
import { ResourcesRS } from '../resources/resources-response';
import { CurrencyRS } from '../site-settings/currency-rs';
import { RoleRef, SiteRelation } from '../team/team';

export interface SiteResponse {
    created_date?: number;
    default_currency?:CurrencyRS;
    id?: string;
    label?: { [key: string]: string; };
    multimedia?: ResourcesRS;
    owner_id?: string;
    site_name?: string;
    status?: SiteResponse.StatusTypeEnum;
    sub_domain?: string;
    type?: SiteResponse.TypeEnum;
    updated_date?: number;
    isMenuCollapsed?: boolean;
    siteRoutes?:RouteInfo;
    building_status?: SiteResponse.BuildingStatus;
    pos_enabled?: boolean;
    /** Del directorio de tiendas accesibles: propia (OWNER) o compartida (MEMBER). */
    relation?: SiteRelation;
    /** Rol del usuario en una tienda compartida. */
    role?: RoleRef | null;
    /** Dueño de una tienda compartida. */
    owner_name?: string | null;
}

export namespace SiteResponse {
    export type StatusTypeEnum = 'UNPUBLISHED' | 'PUBLISHED';
    export const StatusTypeEnum = {
        UNPUBLISHED: 'UNPUBLISHED' as StatusTypeEnum,
        PUBLISHED: 'PUBLISHED' as StatusTypeEnum
    };
    export type TypeEnum = 'STORE' | 'BUY_SELL' | 'SUB_STORE' | 'VACATIONAL' | 'JOB' | 'HOME';
    export const TypeEnum = {
        STORE: 'STORE' as TypeEnum,
        BUYSELL: 'BUY_SELL' as TypeEnum,
        SUBSTORE: 'SUB_STORE' as TypeEnum,
        VACATIONAL: 'VACATIONAL' as TypeEnum,
        JOB: 'JOB' as TypeEnum,
        HOME: 'HOME' as TypeEnum
    };

    export enum BuildingStatus {
        PREPARING_EXAMPLE_DATA = 'PREPARING_EXAMPLE_DATA',
        EXAMPLE_DATA_CREATED = 'EXAMPLE_DATA_CREATED',
        PREPARING_STORE = 'PREPARING_STORE',
        CONFIGURING_SUB_DOMAIN = 'CONFIGURING_SUB_DOMAIN',
        INITIALIZED = 'INITIALIZED'
    }
}
